export default __webpack_public_path__ + "static/media/05B.060.c8f21510.png";